import React__default, { Component } from 'react';
import { __extends, __rest, __assign } from '../../_virtual/_tslib.js';
import withChat from '../Provider/withChat.js';
import ConversationQuery from '../ConversationQuery/index.js';

var MessageQuery =
/** @class */
function (_super) {
  __extends(MessageQuery, _super);

  function MessageQuery(props) {
    var _this = _super.call(this, props) || this; // TODO: Call `load` in the constructor to prevent this loading state.
    //   We will need to remove the state side-effects of `load` first.


    _this.state = {
      loading: !!_this.props.conversation
    };
    _this.load = _this.load.bind(_this);
    _this.cancel = _this.cancel.bind(_this);
    _this.fetchMore = _this.fetchMore.bind(_this);
    _this.handleMessagesLoaded = _this.handleMessagesLoaded.bind(_this);
    return _this;
  }

  MessageQuery.prototype.componentDidMount = function () {
    if (!this.query) {
      this.load(this.props.conversation);
    }
  };

  MessageQuery.prototype.componentDidUpdate = function (prevProps) {
    // Firebase client no longer available, or no conversation ID provided
    if (!this.props.chatClient) {
      this.cancel();
    } // Conversation or authenticated user has changed


    if (this.props.chatClient && (prevProps.authenticatedUserId !== this.props.authenticatedUserId || prevProps.conversation.conversationId !== this.props.conversation.conversationId)) {
      this.cancel();
      this.load(this.props.conversation);
    }
  };

  MessageQuery.prototype.componentWillUnmount = function () {
    this.cancel();
  };

  MessageQuery.prototype.load = function (conversation) {
    this.query = conversation.getMessageQuery(this.props.pageSize);

    if (this.query.initialized) {
      // If the query is already initialized, handle the existing messages and skip the loading state.
      this.handleMessagesLoaded();
    } else {
      // Otherwise, enter a loading state and handle the results asyncronously.
      this.setState({
        messages: undefined,
        loading: true
      });
    }

    this.query.once('initialized', this.handleMessagesLoaded, this);
    this.query.on('updated', this.handleMessagesLoaded, this);
  };

  MessageQuery.prototype.cancel = function () {
    if (this.query) {
      this.query.off('initialized', this.handleMessagesLoaded, this);
      this.query.off('updated', this.handleMessagesLoaded, this);
      this.query.close();
      delete this.query;
    }
  };

  MessageQuery.prototype.handleMessagesLoaded = function () {
    if (this.query) {
      var _a = this.query,
          messages = _a.messages,
          hasMore = _a.hasMore;
      /**
       * Call "onCompleted" before setting loading = false so that the fetchEvents query is called first (if provided)
       * This prevents the converation from attempting to render until all the needed data is fetched (including any potential events)
       */

      if (this.props.onCompleted) {
        this.props.onCompleted({
          messages: messages,
          hasMore: hasMore
        });
      }

      this.setState({
        messages: messages,
        hasMore: hasMore,
        loading: false
      });
    }
  };

  MessageQuery.prototype.fetchMore = function () {
    var _this = this;

    if (this.query) {
      this.setState({
        loading: true
      });
      return this.query.more(this.props.fetchMorePageSize).then(function (_a) {
        var messages = _a.messages,
            hasMore = _a.hasMore;

        _this.setState({
          loading: false,
          messages: messages
        });

        return {
          messages: messages,
          hasMore: hasMore
        };
      });
    }

    return Promise.resolve({
      messages: this.state.messages,
      hasMore: this.state.hasMore
    });
  };

  MessageQuery.prototype.render = function () {
    /**
     * `this.state.loading` only tracks whether the query is unfinished. We also
     *    need to consider the loading/auth state of the Firebase client itself.
     */
    var loading = this.state.loading || !this.props.chatClient;
    return this.props.children({
      loading: loading,
      messages: this.state.messages,
      hasMore: this.state.hasMore,
      fetchMore: this.fetchMore
    });
  };

  MessageQuery.defaultProps = {
    pageSize: 25,
    fetchMorePageSize: 25
  };
  return MessageQuery;
}(Component);

var MessageQueryConversationLoader = function MessageQueryConversationLoader(_a) {
  var conversationId = _a.conversationId,
      children = _a.children,
      rest = __rest(_a, ["conversationId", "children"]);

  return React__default.createElement(ConversationQuery, {
    conversationId: conversationId
  }, function (_a) {
    var loading = _a.loading,
        conversation = _a.conversation;

    if (loading) {
      return children({
        loading: true,
        fetchMore: function fetchMore() {
          return Promise.resolve({});
        }
      });
    }

    if (!conversationId) {
      return children({
        loading: false,
        hasMore: false,
        fetchMore: function fetchMore() {
          return Promise.resolve({});
        }
      });
    }

    return React__default.createElement(MessageQuery, __assign({
      conversation: conversation
    }, rest), function (_a) {
      var error = _a.error,
          hasMore = _a.hasMore,
          loading = _a.loading,
          fetchMore = _a.fetchMore,
          messages = _a.messages;
      return children({
        error: error,
        hasMore: hasMore,
        loading: loading,
        fetchMore: fetchMore,
        messages: messages
      });
    });
  });
};

var MessageQuery$1 = withChat(MessageQueryConversationLoader);

export default MessageQuery$1;
//# sourceMappingURL=index.js.map
